<div class="attachments-gallery" [class]="classList">
  @for(att of attachments; track att.attachmentID) {
  <a href="{{att.url}}" target="_blank" [title]="att.title" class="att">
    <mat-icon svgIcon="attachment"></mat-icon>
    <div class="title">{{ att.title }}</div>
  </a>
  }
</div>